export const selectMessages = ({ messages }) => messages.messages
export const selectIsReceivedMessage = ({ messages }) => messages.isReceivedMessage
export const selectIsReadMessage = ({ messages }) => messages.isReadMessage
export const selectImagesMessage = ({ messages }) => messages.images
